import {AfterViewInit, Component, HostListener, Inject, Injectable, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
  DialogData,
  ZeiterfassungFormdialogNeuComponent
} from '../zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import { select, Store } from '@ngrx/store';
import { Zeitstate } from '../../store/reducer/zeiterfassung.reducer';
import { deleteZeitStart } from '../../store/actions/Zeit-del.actions';
import {loadProjektSelectboxStart} from '../../store/actions/project-selectbox.actions';
import {BestaetigungsFormComponent} from '../../../../ui-components/bestaetigungs-form/bestaetigungs-form.component';
import {loadSpesenStart} from '../../store/actions/getAllSpesen.actions';
import {deleteAllSpesenOfZeitStart,
} from '../../store/actions/allSpesenOfZeit-del.actions';
import {setTimeToZeroStart} from '../../store/actions/setTimeToZero-edit.actions';
import {addZeitStart} from '../../store/actions/Zeit-add.actions';
import {async, Observable} from 'rxjs';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {loadAllMitarbeiterSelectboxStart} from '../../../Mitarbeiterverwaltung/store/actions/getAllMitarbeiterSelectbox.actions';
import {State} from '../../../Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {MitarbeiterItem} from '../../../Mitarbeiterverwaltung/mitarbeiter.model';
import {getFilteredSeekDateStart} from '../../store/actions/filter-seek-date.actions';
import {AuswertungenFormdialogNeuComponent} from '../../../auswertungen/components/auswertungen-formdialog-neu/auswertungen-formdialog-neu.component';
import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';
import * as moment from 'moment';
import {ZeiterfassungFilterComponent} from '../zeiterfassung-filter/zeiterfassung-filter.component';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Security} from '../../../../security';
import {alleVerrechnetStart} from '../../store/actions/alleVerrechnet.actions';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {loadSaldoStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getSaldo.actions';
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';
import {loadSaldoReportStart} from '@src/app/pages/Zeiterfassung/store/actions/getSaldoReport.actions';
import {AuswertungFerienFormComponent} from '@src/app/pages/auswertungen/components/auswertungenferien-form/auswertungenferien-form.component';
import {getFerienReportStarted} from '@src/app/pages/Zeiterfassung/store/actions/getFerienReport';
import {getFilteredZeitStarted} from '@src/app/pages/auswertungen/store/actions/filter-seek-date.actions';
import {AuswertungenService} from '@src/app/pages/auswertungen/auswertungen.service';
import {ZeitService} from '@src/app/pages/Zeiterfassung/zeit.service';

@Component({
  selector: 'app-zeiterfassung-page',
  templateUrl: './zeiterfassung-page.component.html',
  styleUrls: ['./zeiterfassung-page.component.scss']
})

export class ZeiterfassungPageComponent implements OnInit, OnDestroy, AfterViewInit {


  // tslint:disable-next-line:max-line-length
  public static showZeittable = true;
  // tslint:disable-next-line:max-line-length
  constructor( public dialog: MatDialog,
               public store: Store<{ zeiterfassung: Zeitstate }>,
               private mitarbeiterStore: Store<{ mitarbeiterverwaltung: State }>,
               public http: HttpClient,
               public router: Router,
               public security: Security,
               private breakpointObserver: BreakpointObserver,
               public aService: AuswertungenService,
               public zService: ZeitService
  ) {

 //   console.log( checkGrant('3000', this.http, this.router));
    const today = new Date();
    this.$zeit = store.pipe(select((state) => state.zeiterfassung.item)); /* items */
    this.$user = mitarbeiterStore.pipe(select((state) => state.mitarbeiterverwaltung.selectboxItems));
    this.$saldo = mitarbeiterStore.pipe(select((state) => state.mitarbeiterverwaltung.saldos));
    this.rolleId = sessionStorage.getItem('rolleId');

    this.filterSucheForm.patchValue({
      datumVon: new Date(today.getFullYear(), today.getMonth(), 1),
      datumBis: new Date(today.getFullYear(), today.getMonth() + 1, 0),
    });

  }
  public showAdd: Observable<boolean>;
  public showPrint: Observable<boolean>;
  public showChangeUser: Observable<boolean>;
  public $saldo: Observable<SaldoItem>;
  public userId;
  public rolleId: string;
  public title;
  public functionMenuEnabled: boolean;
  public isFilterActive: boolean;
  public $zeit;
  public wertDerCheckboxPage;
  public myTimer: any;
  public isSmallDevice = false;

  public $user: Observable<MitarbeiterItem[]>;

  public userForm = new FormGroup({
    user: new FormControl({value: ''}, [Validators.required]),
  });
  /* Werte der Suche nach Datum und Projektname gespeichert */
  public filterSucheForm = new FormGroup({
    datumVon: new FormControl(''),
    datumBis: new FormControl(''),
    sucheProjekte: new FormControl(''),
    zuverrechnen: new FormControl(''),
  });


  ngOnInit(): void {
    this.showAdd = this.security.checkIfAllowed('3002');
    this.showPrint = this.security.checkIfAllowed('4000');
    this.showChangeUser = this.security.checkIfAllowed('3001');
    this.functionMenuEnabled = true;
    this.isFilterActive = false;
    this.breakpointObserver
      .observe(localStorage.getItem('phoneWidth'))
      .pipe(map((result) => result.matches))
      .subscribe((isSmallDevice) => {
        this.isSmallDevice = isSmallDevice;
      });
   /* let userId = null;
    // Falls zeitUserId gesetzt ist
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    // Falls der aktive User genommen werden soll.
    else{
      userId = sessionStorage.getItem('userId');
    }
    console.log(userId);
    this.userForm.patchValue({
      user: userId,
    });
    this.store.dispatch(loadAllMitarbeiterSelectboxStart({string: sessionStorage.getItem('firmaId')}));
*/
  }

  ngAfterViewInit(): void {
    ZeiterfassungPageComponent.showZeittable = true;
    this.search();

    this.myTimer = setInterval( function(): void{
      if ( sessionStorage.getItem('session') !== null ){
        document.getElementById('timerButton').click();
      }

    }  , 300);
  }

  ngOnDestroy(): void {
    this.functionMenuEnabled = true;
    this.store.dispatch(loadAllMitarbeiterSelectboxStart({string: sessionStorage.getItem('firmaId')}));
    sessionStorage.setItem('zeitUserId', 'null');
    clearInterval(this.myTimer);
  }

  // Wandelt Datum in das richtige Format
  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }

  public openAuswertungen(projektId: number): void{

    if(projektId == 0){
      this.store.dispatch(loadProjektSelectboxStart({projektId: parseInt( sessionStorage.getItem('zeitFilterPrjId'), 10)}));
    }
    else{
      this.store.dispatch(loadProjektSelectboxStart({projektId}));
    }
    // this.store.dispatch(loadProjektSelectboxStart({projektId}));

    if(this.isSmallDevice){
      this.dialog.open(AuswertungenFormdialogNeuComponent, {
        minWidth: '100vw',
        height: '100vh',
        data: {
          title: 'pages.auswertungen.auswertungDialog.title',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          start: sessionStorage.getItem('zeitFilterDatumVon'),
          ende: sessionStorage.getItem('zeitFilterDatumBis'),
          verrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
        },
      }).afterClosed().subscribe(
        (result) => {
          if (result){
            console.log(result);
            this.store.dispatch(getFilteredZeitStarted({item: result}));
            this.aService.getFilteredSeekDate(result).subscribe(
              (x) => {
                // tslint:disable-next-line:max-line-length
                this.loadReport(result.benutzer, result.zwischensummen, result.details, result.alleBenutzer, result.start, result.ende, result.zeitAuswahl, result.spesenAuswahl, result.separat);
              });
          }
        }
      );
    }
    else{
      this.dialog.open(AuswertungenFormdialogNeuComponent, {
        data: {
          title: 'pages.auswertungen.auswertungDialog.title',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          start: sessionStorage.getItem('zeitFilterDatumVon'),
          ende: sessionStorage.getItem('zeitFilterDatumBis'),
          verrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
        },
      }).afterClosed().subscribe(
        (result) => {
          if (result){
          //  this.store.dispatch(getFilteredZeitStarted({item: result}));
            this.aService.getFilteredSeekDate(result).subscribe(
              (x) => {
                // tslint:disable-next-line:max-line-length
                this.loadReport(result.benutzer, result.zwischensummen, result.details, result.alleBenutzer, result.start, result.ende, result.zeitAuswahl, result.spesenAuswahl, result.separat);
              });
          }
        }
      );
    }
  }

  public openFerienReport(): void{
    this.dialog.open(AuswertungFerienFormComponent, {
      data: {
        title: 'pages.auswertungen.auswertungDialog.title',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
      },
    }).afterClosed().subscribe(
      (nResult) => {
        if (nResult){
          // this.store.dispatch(getFerienReportStarted({jahr: nResult.jahr, mitarbeiter: nResult.mitarbeiter}));
          console.log(nResult);
          // Load Ferien Report
          this.zService.getFerienReport(nResult.jahr, nResult.mitarbeiter).subscribe(
            (x) => {
              // tslint:disable-next-line:max-line-length
              this.loadFerienReport(nResult);
            });
        }
      }
    );
  }


  /* öffnet Maske für die neue Zeiterfassung */
  public newAddtime(): void{
    // Zeit in Datenbank erstellen und ID mit in Formular geben via Session
    this.store.dispatch(addZeitStart());
    this.store.dispatch(loadSpesenStart({zeitId: 0} ));

    // bei kleinen Geräten Vollbildschirm
    if (this.isSmallDevice){
      this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
        minWidth: '100vw',
        height: '100vh',
        data: {
          title: 'pages.addTimeDialog.title',
          spesenTitle: 'pages.addTimeDialog.spesenTitle',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          dauerIntern: 0,
          dauerExtern: 0,
        },
      });
    }
    // Bei grossen Geräten nicht Vollbildschirm
    else{
      this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
        data: {
          title: 'pages.addTimeDialog.title',
          spesenTitle: 'pages.addTimeDialog.spesenTitle',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          dauerIntern: 0,
          dauerExtern: 0,
        },
      });
    }

  }
  public setNewUserSession(userId: string): void {
    sessionStorage.setItem('zeitUserId', userId);
    // tslint:disable-next-line:radix
    this.store.dispatch(loadSaldoStart({userId: parseInt(userId)}));
    // holt alle gefilterten Zeiteinträge für die neue Person
    this.store.dispatch(getFilteredSeekDateStart({
      string: sessionStorage.getItem('zeitFilterSearchString'),
      item: {
        datumVon: sessionStorage.getItem('zeitFilterDatumVon'),
        datumBis: sessionStorage.getItem('zeitFilterDatumBis'),
        zuverrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
      }
    })
    );
  }
  /* Bearbeiten eines Eintrags */

  public editZeit(Zeit: DialogData): void {
    this.store.dispatch(loadSpesenStart({zeitId: Zeit.id} ));
    this.store.dispatch(loadProjektSelectboxStart({projektId: parseInt(Zeit.projekt)}));
   // Hier muss man mit der ZeitId den Projektbaum holen gehen und dann in das Zeitform mitgeben ->
    if(this.isSmallDevice) {
      // tslint:disable-next-line:radix

      const dialogEdit = this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
        minWidth: '100vw',
        height: '100vh',
        data: {
          title: 'pages.timeDialog.functionMenu.title',
          spesenTitle: 'pages.addTimeDialog.spesenTitle',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          id: Zeit.id,
          datum: Zeit.datum,
          dauerIntern: Zeit.dauerIntern,
          dauerExtern: Zeit.dauerExtern,
          text: Zeit.text,
          verrechnen: Zeit.verrechnen,
          verrechnet: Zeit.verrechnet,
          niverbar: Zeit.niverbar,
          sollZeit: Zeit.sollZeit,
          istZeit: Zeit.istZeit,
          restZeit: Zeit.restZeit,
          ferien: Zeit.ferien,
        },
      });
      dialogEdit.afterClosed().subscribe(result => {
        this.store.dispatch(loadSpesenStart({zeitId: 0}));
      });
    }
    else{
      // tslint:disable-next-line:radix
      const dialogEdit = this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
        data: {
          title: 'pages.timeDialog.functionMenu.title',
          spesenTitle: 'pages.addTimeDialog.spesenTitle',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          id: Zeit.id,
          datum: Zeit.datum,
          dauerIntern: Zeit.dauerIntern,
          dauerExtern: Zeit.dauerExtern,
          text: Zeit.text,
          verrechnen: Zeit.verrechnen,
          verrechnet: Zeit.verrechnet,
          niverbar: Zeit.niverbar,
          sollZeit: Zeit.sollZeit,
          istZeit: Zeit.istZeit,
          restZeit: Zeit.restZeit,
          ferien: Zeit.ferien,
        },
      });
      dialogEdit.afterClosed().subscribe(result => {
        this.store.dispatch(loadSpesenStart({zeitId: 0}));
      });
    }
  }

  public deleteZeit(Zeit: DialogData): void {


    // Falls deletable true ist muss nur gefragt werden ob die Zeit gelöscht werden soll.
    // Falls deletable false ist muss auch für die Spesen der Zeit gefragt werden.
    // Falls der User die Spesen nicht löschen will kann er die Zeit trotzdem löschen ( Auf 0Stunden Arbeit setzen )
    if (Zeit.deletable === false){
    // Abfrage ob Spesen gelöscht werden sollen.
      const bestätigungsFormSpese = this.dialog.open(BestaetigungsFormComponent, {
        data: {
          title: 'pages.zeitverwaltung.deleteAllSpesen.title',
          text: 'pages.zeitverwaltung.deleteAllSpesen.text'
        },
      });
      bestätigungsFormSpese.afterClosed().subscribe(result => {
        if (result === true){
          // Spesen löschen
          this.store.dispatch(deleteAllSpesenOfZeitStart({zeitId: Zeit.id}));

          // Abfrage ob Zeit auch gelöscht werden soll.

          const bestätigungsForm = this.dialog.open(BestaetigungsFormComponent, {
            data: {
              title: 'pages.zeitverwaltung.deleteZeit.title',
              text: 'pages.zeitverwaltung.deleteZeit.text'
            },
          });
          bestätigungsForm.afterClosed().subscribe(result2 => {
            if (result2 === true){
              // Zeit löschen
              this.store.dispatch(deleteZeitStart({item: Zeit}));
            }
          });

        }
        else{
          // Abfrage ob Zeit auf 0 gestellt werden soll
          const bestätigungsFormZeitAuf0 = this.dialog.open(BestaetigungsFormComponent, {
            data: {
              title: 'pages.zeitverwaltung.updateZeitZu0.title',
              text: 'pages.zeitverwaltung.updateZeitZu0.text'
            },
          });
          bestätigungsFormZeitAuf0.afterClosed().subscribe(result2 => {
            if (result2 === true){
              // Zeit muss auf 0 gestellt werden
              this.store.dispatch(setTimeToZeroStart({zeit: Zeit}));
            }
          });
        }
      });
    }
    else{
      // Abfrage ob Zeit gelöscht werden soll.
      const bestätigungsForm = this.dialog.open(BestaetigungsFormComponent, {
        data: {
          title: 'pages.zeitverwaltung.deleteZeit.title',
          text: 'pages.zeitverwaltung.deleteZeit.text'
        },
      });
      bestätigungsForm.afterClosed().subscribe(result => {
        if (result === true){
          this.store.dispatch(deleteZeitStart({item: Zeit}));
        }
      });
    }

  }

  public saldoReport(userId: number): void {
    console.log(userId);

    this.zService.getSaldo(userId).subscribe(
      (x) => {
        // tslint:disable-next-line:max-line-length
       // this.store.dispatch(loadSaldoReportStart({userId}));

        ZeiterfassungPageComponent.showZeittable = false;
        Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmpMFGIvKXt+0qL8oOfYCePmdl89Db00G622UYvHM74Kho8fxVfA5Hmk/iCgfRw7qeEsRlVjqwg8RcFeEAnQymDk5yd2/okky1fZy4MSoewgM6OUcbcojaqaY96fyQa5VlONSe6PWNNVBCmoaUL/YJZeg4AuxBQvIJFZmwtDvfOZ/ug9VdKB8h8mmoSQhvA1qANoYclQR1kaTNBAXKsrVcn8MKItIoVrJZY0/lINUiPZHfARTMWfdhA5t+UjQQOwWLTIxMha5bsoCfjFG7maIk/ES4kO2OKR5k6Huxg6PBg8lwtn+cw3kQ4pD46VgGTRXh7xCxAUD9hMf5F9rDFyctBRH1o7pdYbHFApsyLcRNoDnefn/LdRAAY+eDs3xTWs4fIslZs+w2EmySosds9X/z6sk6iTQoXrKXmHHnVMP0chZiZgAXLpvMYCquWuahBiCauNLIFdfw3sChkTwWJJln6CFdK+44o6HflqSNu7MmaJGT+qi6XWcAxKBbYkKq81+o=';
    // Einstellungen für Viewer / nicht alle Export und Prints eingestellt da viel unnötig sind und nur verwirren.
        const options = new Stimulsoft.Viewer.StiViewerOptions();
        options.width = 2000;
        options.exports.showExportToCsv = false;
        options.exports.showExportToHtml = false;
        options.exports.showExportToHtml5 = false;
        options.exports.showExportToPowerPoint = false;
        options.exports.showExportToImageSvg = false;
        options.exports.showExportToOpenDocumentWriter = false;
        options.exports.showExportToText = false;
        options.exports.showExportToOpenDocumentCalc = false;
        options.exports.showExportToDocument = false;
        options.toolbar.showOpenButton = false;
        options.toolbar.viewMode = Stimulsoft.Viewer.StiWebViewMode.Continuous;


        options.toolbar.printDestination = Stimulsoft.Viewer.StiPrintDestination.Pdf;
        const report = new Stimulsoft.Report.StiReport();
        const viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

    // Load Report File
    // tslint:disable-next-line:max-line-length
        report.loadFile(window.location.protocol + '//' + window.location.hostname + '/myDay/backend/auswertungen/temp/saldoReport_'
        + sessionStorage.getItem('session').slice(10) + '.json');

        viewer.report = report;

    // Rendering the viewer to selected element
        viewer.renderHtml('viewer');

    // Button zu StimulsoftViewer hinzufügen
    // tslint:disable-next-line:prefer-const
        let userButton = viewer.jsObject.SmallButton('userButton', 'Schliessen', 'emptyImage');
    // userButton.image.src = false;
    // Schliessen des Report Fensters
    // tslint:disable-next-line:only-arrow-functions typedef
        userButton.action = function() {
      this.jsObject.controls.viewer.parentNode.removeChild(this.jsObject.controls.viewer);
      ZeiterfassungPageComponent.showZeittable = true;
    };

        const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
        const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
        const userButtonCell = buttonsTable.rows[0].insertCell(0);
        userButtonCell.className = 'stiJsViewerClearAllStyles';
        userButtonCell.appendChild(userButton);

      });
  }

  public       loadReport(
                    showBenutzername: boolean,
                    showZwischensummen: boolean,
                    showDetails: boolean,
                    showAllUsers: boolean,
                    filterDatumStart: string,
                    filterDatumEnde: string,
                    zeitAuswahl: number,
                    spesenAuswahl: number,
                    showSeparat: boolean
  ): void{

    ZeiterfassungPageComponent.showZeittable = false;
    Stimulsoft.StiOptions.WebServer.url = 'https://local.curion.ch/stimulsoftDesigner/reports/handler.php';
    Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmpMFGIvKXt+0qL8oOfYCePmdl89Db00G622UYvHM74Kho8fxVfA5Hmk/iCgfRw7qeEsRlVjqwg8RcFeEAnQymDk5yd2/okky1fZy4MSoewgM6OUcbcojaqaY96fyQa5VlONSe6PWNNVBCmoaUL/YJZeg4AuxBQvIJFZmwtDvfOZ/ug9VdKB8h8mmoSQhvA1qANoYclQR1kaTNBAXKsrVcn8MKItIoVrJZY0/lINUiPZHfARTMWfdhA5t+UjQQOwWLTIxMha5bsoCfjFG7maIk/ES4kO2OKR5k6Huxg6PBg8lwtn+cw3kQ4pD46VgGTRXh7xCxAUD9hMf5F9rDFyctBRH1o7pdYbHFApsyLcRNoDnefn/LdRAAY+eDs3xTWs4fIslZs+w2EmySosds9X/z6sk6iTQoXrKXmHHnVMP0chZiZgAXLpvMYCquWuahBiCauNLIFdfw3sChkTwWJJln6CFdK+44o6HflqSNu7MmaJGT+qi6XWcAxKBbYkKq81+o=';

    // Einstellungen für Viewer / nicht alle Export und Prints eingestellt da viel unnötig sind und nur verwirren.
    const options = new Stimulsoft.Viewer.StiViewerOptions();
    options.width = 2000;
    options.exports.showExportToCsv = false;
    options.exports.showExportToHtml = false;
    options.exports.showExportToHtml5 = false;
    options.exports.showExportToPowerPoint = false;
    options.exports.showExportToImageSvg = false;
    options.exports.showExportToOpenDocumentWriter = false;
    options.exports.showExportToText = false;
    options.exports.showExportToOpenDocumentCalc = false;
    options.exports.showExportToDocument = false;
    options.toolbar.showOpenButton = false;
    options.toolbar.viewMode = Stimulsoft.Viewer.StiWebViewMode.Continuous;


    options.toolbar.printDestination = Stimulsoft.Viewer.StiPrintDestination.Pdf;
    const report = new Stimulsoft.Report.StiReport();
    const viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
    // Load report from url

    // Load Report File
    // tslint:disable-next-line:max-line-length
    report.loadFile(window.location.protocol + '//' + window.location.hostname + '/myDay/backend/auswertungen/temp/zeitReport_' + sessionStorage.getItem('session').slice(10) + '.json');
    // Variabel Übergabe
    //  report.loadFile(window.location.protocol + '//' + window.location.hostname + '/myDay/backend/auswertungen/zeitReport.mrt');
    report.dictionary.variables.getByName('showName').valueObject = showBenutzername;
    report.dictionary.variables.getByName('showZwischensummen').valueObject = showZwischensummen;
    report.dictionary.variables.getByName('showDetails').valueObject = showDetails;
    report.dictionary.variables.getByName('showAllUsers').valueObject = showAllUsers;
    report.dictionary.variables.getByName('filterDatumStart').valueObject = filterDatumStart;
    report.dictionary.variables.getByName('filterDatumEnde').valueObject = filterDatumEnde;
    report.dictionary.variables.getByName('showZeit').valueObject = zeitAuswahl;
    report.dictionary.variables.getByName('showSpesen').valueObject = spesenAuswahl;
    report.dictionary.variables.getByName('showSeparat').valueObject = showSeparat;
    viewer.report = report;

    // Rendering the viewer to selected element
    viewer.renderHtml('viewer');

    // Button zu StimulsoftViewer hinzufügen
    // tslint:disable-next-line:prefer-const
    let userButton = viewer.jsObject.SmallButton('userButton', 'Schliessen', 'emptyImage');
   // userButton.image.src = false;
    // Schliessen des Report Fensters
    // tslint:disable-next-line:only-arrow-functions typedef
    userButton.action = function() {
      this.jsObject.controls.viewer.parentNode.removeChild(this.jsObject.controls.viewer);
      ZeiterfassungPageComponent.showZeittable = true;
    };

    const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
    const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
    const userButtonCell = buttonsTable.rows[0].insertCell(0);
    userButtonCell.className = 'stiJsViewerClearAllStyles';
    userButtonCell.appendChild(userButton);

  }


  public   loadFerienReport(
    nJahr: number
  ): void{
        console.log(nJahr);
        ZeiterfassungPageComponent.showZeittable = false;

        Stimulsoft.StiOptions.WebServer.url = 'https://local.curion.ch/stimulsoftDesigner/reports/handler.php';
        Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHmpMFGIvKXt+0qL8oOfYCePmdl89Db00G622UYvHM74Kho8fxVfA5Hmk/iCgfRw7qeEsRlVjqwg8RcFeEAnQymDk5yd2/okky1fZy4MSoewgM6OUcbcojaqaY96fyQa5VlONSe6PWNNVBCmoaUL/YJZeg4AuxBQvIJFZmwtDvfOZ/ug9VdKB8h8mmoSQhvA1qANoYclQR1kaTNBAXKsrVcn8MKItIoVrJZY0/lINUiPZHfARTMWfdhA5t+UjQQOwWLTIxMha5bsoCfjFG7maIk/ES4kO2OKR5k6Huxg6PBg8lwtn+cw3kQ4pD46VgGTRXh7xCxAUD9hMf5F9rDFyctBRH1o7pdYbHFApsyLcRNoDnefn/LdRAAY+eDs3xTWs4fIslZs+w2EmySosds9X/z6sk6iTQoXrKXmHHnVMP0chZiZgAXLpvMYCquWuahBiCauNLIFdfw3sChkTwWJJln6CFdK+44o6HflqSNu7MmaJGT+qi6XWcAxKBbYkKq81+o=';

        // Einstellungen für Viewer / nicht alle Export und Prints eingestellt da viel unnötig sind und nur verwirren.
        const options = new Stimulsoft.Viewer.StiViewerOptions();
        options.width = 2000;
        options.exports.showExportToCsv = false;
        options.exports.showExportToHtml = false;
        options.exports.showExportToHtml5 = false;
        options.exports.showExportToPowerPoint = false;
        options.exports.showExportToImageSvg = false;
        options.exports.showExportToOpenDocumentWriter = false;
        options.exports.showExportToText = false;
        options.exports.showExportToOpenDocumentCalc = false;
        options.exports.showExportToDocument = false;
        options.toolbar.showOpenButton = false;
        options.toolbar.viewMode = Stimulsoft.Viewer.StiWebViewMode.Continuous;


        options.toolbar.printDestination = Stimulsoft.Viewer.StiPrintDestination.Pdf;
        const report = new Stimulsoft.Report.StiReport();
        const viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
        // Load report from url

        // Load Report File
        // tslint:disable-next-line:max-line-length
        report.loadFile(window.location.protocol + '//' + window.location.hostname + '/myDay/backend/auswertungen/temp/ferienReport_' + sessionStorage.getItem('session').slice(10) + '.json');
        // Variabel Übergabe
        //  report.loadFile(window.location.protocol + '//' + window.location.hostname + '/myDay/backend/auswertungen/zeitReport.mrt');
        report.dictionary.variables.getByName('jahr').valueObject = nJahr;
        viewer.report = report;

        // Rendering the viewer to selected element
        viewer.renderHtml('viewer');

        // Button zu StimulsoftViewer hinzufügen
        // tslint:disable-next-line:prefer-const
        let userButton = viewer.jsObject.SmallButton('userButton', 'Schliessen', 'emptyImage');
        // userButton.image.src = false;
        // Schliessen des Report Fensters
        // tslint:disable-next-line:only-arrow-functions typedef
        userButton.action = function() {
          this.jsObject.controls.viewer.parentNode.removeChild(this.jsObject.controls.viewer);
          ZeiterfassungPageComponent.showZeittable = true;
        };

        const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
        const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
        const userButtonCell = buttonsTable.rows[0].insertCell(0);
        userButtonCell.className = 'stiJsViewerClearAllStyles';
        userButtonCell.appendChild(userButton);

  }

  public search(): void{
    let searchString = '';

    const item: any = {datumVon: Date, datumBis: Date, zuverrechnen: Number};
    // Datum ausgefüllt
    if (this.filterSucheForm.value.datumBis && this.filterSucheForm.value.datumVon){
      searchString += 'datumVondatumBis';
      item.datumVon = this.wandler(this.filterSucheForm.value.datumVon);
      item.datumBis = this.wandler(this.filterSucheForm.value.datumBis);
    }
    // Nur Datum Von ausgefüllt
    else if (this.filterSucheForm.value.datumVon){
      searchString += 'datumVon';
      item.datumVon = this.wandler(this.filterSucheForm.value.datumVon);
    }
    // Nur Datum Bis ausgefüllt
    else if (this.filterSucheForm.value.datumBis){
      searchString += 'datumBis';
      item.datumBis = this.wandler(this.filterSucheForm.value.datumBis);
    }
    searchString += 'zuverrechnen';
    if (this.filterSucheForm.value.zuverrechnen === true){
      item.zuverrechnen = 1;
    }
    else{
      item.zuverrechnen = 0;
    }

    sessionStorage.setItem('zeitFilterDatumBis', item.datumBis );
    sessionStorage.setItem('zeitFilterDatumVon', item.datumVon );
    sessionStorage.setItem('zeitFilterZuverrechnen', item.zuverrechnen );
    sessionStorage.setItem('zeitFilterPrjId', '');
    sessionStorage.setItem('zeitFilterSearchString', searchString);

    if (searchString.length === 0 ){
      // THROW ERROR , mind. 1 Datumfeld muss ausgefüllt sein

    }
    else {
      this.store.dispatch(getFilteredSeekDateStart({string: searchString, item})); /*getFilteredProjektStart*/
    }
    this.isFilterActive = false;
  }

  public getShowtable(): boolean{
    return ZeiterfassungPageComponent.showZeittable;
  }

  public openFilter(): void{
    // tslint:disable-next-line:radix
    this.store.dispatch(loadProjektSelectboxStart({projektId: parseInt( sessionStorage.getItem('zeitFilterPrjId'))}));
    const filterForm = this.dialog.open(ZeiterfassungFilterComponent, {
      data: {
        title: 'pages.zeitverwaltung.filter.title',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        start: sessionStorage.getItem('zeitFilterDatumVon'),
        ende: sessionStorage.getItem('zeitFilterDatumBis'),
        verrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
      },
    });
    filterForm.afterClosed().subscribe(result => {
      if (result === true) {
        this.isFilterActive = true;
      }
      else{
        this.isFilterActive = false;
        this.search();
      }
    });
  }

  public deleteFilter(): void{
    this.isFilterActive = false;
    this.search();
  }

  public alleVerrechnen(zeiten: DialogData): void{


    const bestätigungsForm = this.dialog.open(BestaetigungsFormComponent, {
      data: {
        title: 'pages.zeitverwaltung.alleVerrechnet.title',
        text: 'pages.zeitverwaltung.alleVerrechnet.text'
      },
    });
    bestätigungsForm.afterClosed().subscribe(result => {
      if (result === true){
        this.store.dispatch(alleVerrechnetStart({items: zeiten}));
      }
    });
  }

  public timer(): void{
    this.search();
    this.store.dispatch(loadAllMitarbeiterSelectboxStart({string: sessionStorage.getItem('firmaId')}));
    this.userForm.patchValue({
      user: sessionStorage.getItem('userId'),
    });
    clearInterval(this.myTimer);
  }


}
